import React from 'react';

type Props = {
  paletteColors: string[];
  value: string;
  onChange: (value: string) => void;
};

export default function Swatch({ paletteColors, value, onChange }: Props) {
  const renderButton = (colorValue: string) => {
    const isSelected = value === colorValue;
    return (
      <button
        key={colorValue}
        onClick={() => onChange(colorValue)}
        className="w-6 h-6 min-w-6 inline-flex rounded border transition-colors"
        style={{
          backgroundColor: colorValue,
          borderColor: isSelected ? 'black' : 'hsl(var(--border))',
          borderWidth: isSelected ? '2px' : '1px',
        }}
      />
    );
  };
  return (
    <div className="w-full grid gap-1 grid-cols-6">
      {paletteColors.map((c) => renderButton(c))}
    </div>
  );
}
